import React from "react";


const GraphPlaceHolder = React.memo(()=> {
    return <div
        className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none bg-white p-8 sm:p-10 rounded-xl">
        <div className="animate-pulse">
            <div className="mt-8 flow-root">
                <div className="overflow-x-auto">
                    <div className="inline-block min-w-full align-middle">
                        <img src={"/assets/img/placeholder-img.png"} alt="placeholder" width='100%' height='100%'/>
                    </div>
                </div>
            </div>
        </div>
    </div>
})

export default GraphPlaceHolder;